import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';

//*MUI
import { Grid } from '@mui/material';
import Button from '../../SubComponent/Button';

//*Services
import { getApplicants, getExamByID, getNextPendingExams } from '../../services/examsService';
import ExamCard from '../../Components/ExamCard/ExamCard';
import cssClasses from './MyExams.module.css';
import notFound from "../../assets/images/icons/not-found.png";

//* Import store
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";

export default function MyExams() {
  const dispatch = useDispatch();

  const [studentList, setStudentList] = useState([]);
  const loggedInUser = useSelector((state) => state.Auth.user);

  const [studentExam, setStudentExam] = useState([]);
  const [serverLastMetaData, setServerLastMetaData] = useState(null);

  useEffect(() => {
    dispatch(actions.activeMenu('exams'));
    getApplicants(loggedInUser?.docId)
      .then((res) => {
        setServerLastMetaData(res.docs.pop());
        let _list = res.docs.map((m) => ({
          docID: m.id,
          ...m.data(),
          examDocId: m.ref.path.split('/')[1],
        }));
        setStudentList([..._list]);
        let ExamList = [];
        for (let i = 0; i < _list.length; i++) {
          const element = _list[i];
          getExamByID(element.examDocId).then((result) => {
            if (result.exists) {
              ExamList.push({ ...result.data(), docId: result.id });
            }
            if (i === _list.length - 1) {
              setStudentExam([...ExamList]);
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  async function loadMore() {
    const lastVisible = serverLastMetaData;

    getNextPendingExams(lastVisible, loggedInUser?.docId).then((res) => {
      setServerLastMetaData(res.docs.pop());
        let _list = res.docs.map((m) => ({
          docID: m.id,
          ...m.data(),
          examDocId: m.ref.path.split('/')[1],
        }));
        setStudentList(pre=>[...pre,..._list]);
        let ExamList = [];
        for (let i = 0; i < _list.length; i++) {
          const element = _list[i];
          getExamByID(element.examDocId).then((result) => {
            if (result.exists) {
              ExamList.push({ ...result.data(), docId: result.id });
            }
            if (i === _list.length - 1) {
              setStudentExam(pre=>[...pre,...ExamList]);
            }
          });
        }
    });
  }

  return (
    <div className={cssClasses.DivContainer}>
      <p className={cssClasses.title}>My Exams</p>
      <Grid container>
        {studentExam.length > 0 && studentList.map((StudentObject, index) => (
            <Fragment
              key={`LatestApplyCard_${StudentObject.name}_LatestApplyCard_${
                index + 1
              }`}
            >
             { studentExam.find((f) => f.docId === StudentObject.examDocId) &&
                <Grid item>
                  <ExamCard
                    studentFormObject={StudentObject}
                    examObject={studentExam.find((f) => f.docId === StudentObject.examDocId)}
                  />
                </Grid>
             }
            </Fragment>
          ))}
      </Grid>
       
       {
        studentList.length === 0 &&
          <div className={cssClasses.ResultsDiv }>
            <img src={notFound} alt={""}  width="40px" height="40px" style={{alignSelf:"center"}}/>
            <p className={cssClasses.title} style={{alignSelf:"center"}}>no results found!</p>
          </div> 
        }
          { studentList.length % 12 === 0  && studentList.length &&
             <div className={cssClasses.ButtonWrapper}>
            <Button
              style={{ color: '#6941C6', backgroundColor: '#ffffff' }}
              btnName={'View More'}
              clicked={() => loadMore()}
            />
          </div>
           } 
    </div>
  );
}
